import { render, staticRenderFns } from "./NewsCarousel.vue?vue&type=template&id=c47fca8c&scoped=true&"
import script from "./NewsCarousel.vue?vue&type=script&lang=js&"
export * from "./NewsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NewsCarousel.vue?vue&type=style&index=0&id=c47fca8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47fca8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VIcon,VImg,VSheet})
